import { useDisclosure } from "@chakra-ui/hooks";
import { useCallback, useContext, useEffect, useState } from "react";
import { Modal, ModalBody, ModalOverlay , ModalHeader , ModalFooter } from "@chakra-ui/modal";
import Card from "components/card/custom";
import { BsPlusCircle } from "react-icons/bs";
import { getAllGatewaysByClient , getGatewayBalance} from "api/graphQL_gateways";
import { getAllOrganizationsSecond } from "api/graphQL_organizations";
import { ClientContext } from "ClientProvider";
import { MdHighlightOff } from "react-icons/md";
import DivLoader from "components/divloader/DivLoader";
import { Select as AntSelect } from "antd";
import { getClientsSecond } from "api/graphQL_clients";
import { FiUploadCloud, FiXCircle } from "react-icons/fi";
import toast from "react-hot-toast";
import { useDropzone } from "react-dropzone";
import Batch from "../../../../../assets/csv/CryptoPayin.csv";
import Papa from "papaparse";
import { createBatchPayin } from "api/graphQL_crypto"


interface iCreateBatchForm {
    org_id: string;
    client_id: string;
    approval_type:string;
    batch_file : any;
    gateway:any;
}

export type AllGatewayObj = {
  name: string;
  id: string;
};

const FileDropzone = ({ label, onFileSelect , onRemoveFile}: { label: string; onFileSelect: (file: string | null) => void , onRemoveFile:any} ) => {
    const [fileName, setFileName] = useState("");
    const onDrop = useCallback((acceptedFiles: File[]) => {
        const file = acceptedFiles[0];
        if (file) {
            const allowedTypes = ["text/csv", "application/vnd.ms-excel"];
            if (allowedTypes.includes(file.type)) {
                setFileName(file.name);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    onFileSelect(reader.result as string);
                };
            } else {
                toast.error("Only CSV files are allowed.");
                setFileName("");
                onFileSelect(""); 
            }
        }
    }, [onFileSelect]);
    const removeFile = () => {
        onRemoveFile(true);
        setFileName("");
        onFileSelect("");
    };
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
    });
    return (
        <div
            {...getRootProps()}
            className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-400/30 
            rounded-xl cursor-pointer bg-white/70 dark:bg-gray-800/70 backdrop-blur-lg hover:border-blue-500 
            hover:shadow-xl transition-all duration-300 w-full h-36 shadow-lg dark:shadow-gray-900/40 relative"
        >
            <input {...getInputProps()} />
            {fileName  ? (
                <div className="relative flex items-center gap-2">
                    <FiUploadCloud className="text-green-600 text-xl" />
                    <span className="text-sm dark:text-white">{fileName}</span>
                    <button
                    onClick={(e) => {
                        e.stopPropagation();
                        removeFile();
                    }}
                    className="ml-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-all"
                    >
                    <FiXCircle className="text-sm" />
                    </button>
                </div>
            ) : (
                <div className="flex flex-col items-center">
                    <FiUploadCloud className="text-blue-500 text-4xl mb-3 transition-transform duration-300 hover:scale-110" />
                    <p className="text-gray-600 text-sm dark:text-gray-300 font-medium">{label}</p>
                </div>
            )}
        </div>
    );
};

const AddBatchFile = ({
  fetchPayouts
}: {
  fetchPayouts: () => void;
}) => {
    const rootForm = {
        org_id: "",
        client_id: "",
        approval_type : "",
        batch_file:"",
        gateway:""
    };
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isCloseModal, setIsCloseModal] =  useState<boolean>(false);
    const [organizations, setOrganizations] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(500);
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [allOrg,setAllOrg] = useState<any[]>([]);
    const [clients, setClients] = useState<any[]>([]);
    const [formValues, setFormValues] = useState<iCreateBatchForm>(rootForm);
    const [formValuesErr, setFormValuesErr] =useState<iCreateBatchForm>(rootForm);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [batchFile, setBatchFile] = useState<string | null>(null);
    const [removeFile,setRemoveFile] = useState(false)
    const { singleRoleData } = useContext(ClientContext);
    const [allGateways, setAllGateways] = useState<AllGatewayObj[]>([]);
    
    const handleClose = () => {
        setFormValues(rootForm);
        setFormValuesErr(rootForm);
        setBatchFile("")
        setIsCloseModal(true)
        setClients([]);
        setAllGateways([])
        setTimeout(() => {
          setIsCloseModal(false)
          onClose();
        }, 300);
    };

    const fetchOrganizations = () => {
        getAllOrganizationsSecond(
            page,
            pageSize,
            searchTexts,
        )
        .then((data) => {
            setOrganizations(
                data?.[0]?.map((ele: any) => {
                return {
                    name: ele.name,
                    id: ele.id,
                };
                })
            );
            setAllOrg(data?.[0]?.map((ele: any) => {
                return {
                    name: ele.name,
                    id: ele.id,
                };
                }));
        });
    };

    const fetchGateways = (client_id: any) => {
        getAllGatewaysByClient(client_id)
        .then((data) => {
            const filtered = (data ?? []).filter((gateway : any) =>
                gateway?.payment_method?.filterPaymentMethod?.some(
                (method : any) => method.name === "crypto payin" && method.is_Active === true
                )
            );
            const transformed = filtered.map((item:any) => ({
                ...item,
                id: item.gateway_id
            }));
            setAllGateways(transformed);
        })
        .catch((err) => {
        console.error(err);
        })
        .finally(() => {
        });
    };

    const fetchClients = (org_id : any) => {
        if(org_id == "" || org_id == null || org_id == undefined) {
            setClients([]);
        } else {
            const selectedOrgName = allOrg.find(org => org.id === org_id)?.name || '';
            const params = { page: page, per_page: pageSize, searchTexts: selectedOrgName };
            getClientsSecond(params)
            .then((data) => {
                setClients(
                data?.[0]?.map((ele: any) => {
                    return {
                    name: ele.name,
                    id: ele.client_id,
                    };
                })
                );
            });
        }
    };

    useEffect(() => {
        if (typeof batchFile === "string" && batchFile.trim() !== "") {
            setRemoveFile(false);
            setFormValues((preVal: any) => ({
                ...preVal,
                batch_file: batchFile
            }));
            setFormValuesErr((preVal: any) => ({
                ...preVal,
                batch_file: ""
            }));
        }
    }, [batchFile]);

    useEffect(() => {
        if(removeFile) {
            setFormValues((preVal: any) => {
                return { ...preVal, batch_file: ""};
            });
            setFormValuesErr((preVal: any) => {
                return { ...preVal, batch_file: "The field is required" };
            });
        }
    },[removeFile])

    const REQUIRED_HEADERS = ["invoice_currency", "invoice_amount", "payment_currency", "payment_chain", "customer_id", "external_customer_no"];
    
    const validateCSV = (csvDataUri: string) => {

        const base64Data = csvDataUri.replace(/^data:text\/csv;base64,/, '');
        const csvText = atob(base64Data);
        const parsed = Papa.parse<Record<string, string>>(csvText, {
            header: true,
            skipEmptyLines: true
        });

        if (parsed.errors.length > 0) {
            toast.error("CSV parsing failed , please download sample csv file to see data structure");
            return false;
        }

        const data = parsed.data;

        const actualHeaders = Object.keys(data[0] || {});
        const missingHeaders = REQUIRED_HEADERS.filter(h => !actualHeaders.includes(h));
        if (missingHeaders.length > 0) {
            const formattedMissing = missingHeaders.map(h => h.replace(/_/g, ' '));
            toast.error(`Missing headers: ${formattedMissing.join(", ")} , please download sample csv file to see data structure`);
            return false;
        }

        for (let i = 0; i < data.length; i++) {
            const row = data[i];
            for (let header of REQUIRED_HEADERS) {
                if (!row[header] || String(row[header]).trim() === "") {
                    const formattedHeader = header.replace(/_/g, ' ');
                    toast.error(`Row ${i + 2}: "${formattedHeader}" is missing , please download sample csv file to see data structure`);
                    return false;
                }
            }
        }

        return true;
    };

    function validateData() {
        let verifier: iCreateBatchForm;
        if (!formValues?.org_id) {
          verifier = { ...verifier, org_id: "The field is required" };
        }
        if (!formValues?.client_id) {
            verifier = { ...verifier, client_id: "The field is required" };
        }
        if (!formValues?.gateway) {
            verifier = { ...verifier, gateway: "The field is required" };
        }
        if (!formValues?.batch_file) {
            verifier = { ...verifier, batch_file: "The field is required" };
        }
        if (verifier) {
          setFormValuesErr(verifier);
          return false;
        }
        return true;
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        let validate = validateData();
        if (validate) {
            const isValid = validateCSV(formValues.batch_file);
            if (isValid) {
                setIsLoading(true);
                const data = {
                    "client_id" : formValues.client_id,
                    "organization_id" : formValues.org_id,
                    "file" : formValues.batch_file,
                    "gateway": formValues.gateway,
                }
                createBatchPayin(data)
                .then((data:any) => {
                    if(data.message == 'There are no any crypto gateway assigned to client') {
                        toast.error(data.message);    
                        setIsLoading(false);
                    } else {
                        toast.success(data.message);
                        setIsLoading(false);
                        handleClose();
                        fetchPayouts();
                    }
                })
                .catch((err) => {
                })
                .finally(() => {
                });
            }
        }
    }
    

    return (
        <>
            {singleRoleData?.[0]?.crypto?.value?.add_crypto_payin_batch_file && (
                <Card extra="w-fit px-5 cursor-pointer" onClick={() => {fetchOrganizations(); onOpen(); }}>
                    <button className="flex items-center justify-center gap-2 whitespace-nowrap p-5 text-navy-700 outline-none dark:text-gray-200">
                    <BsPlusCircle className="h-5 w-5 text-brand-500" />
                    <span className="text-brand-500"> Crypto Batch Payin</span>
                    </button>
                </Card>
            )}
            <Modal isOpen={isOpen} onClose={() => {}}>
                <ModalOverlay className="bg-[#000] !opacity-30" />
                <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${isOpen && !isCloseModal ? "card-enter" : "card-exit" }`}>
                    <ModalHeader className="py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                        <MdHighlightOff className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white" onClick={handleClose}/>
                        Crypto Batch Payin
                    </ModalHeader>
                    <ModalBody className="p-2">
                        <div className="px-[30px]">
                            <div className="flex gap-5">
                                <div className="w-full">
                                    <label
                                        htmlFor="org_id"
                                        className={`ml-1.5 text-sm font-bold text-gray-900 dark:text-white`}
                                    >
                                        Organization<span className="important">*</span>
                                    </label>
                                    <AntSelect
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        allowClear
                                        placeholder="Select Organization"
                                        optionFilterProp="children"
                                        className="h-[48px] w-full mt-[5px]"
                                        options={organizations?.map((m: any) => {
                                        return {
                                            ...m,
                                            label: m?.name,
                                            value: m?.id,
                                        };
                                        })}
                                        value={formValues?.org_id || undefined}
                                        onChange={(e: any) => {
                                            setFormValues((preVal: any) => {
                                                return { ...preVal, org_id: e , client_id : "" , gateway : ""};
                                            });
                                            setFormValuesErr((preVal: any) => {
                                                return { ...preVal, org_id: "" };
                                            });
                                            setAllGateways([])
                                            fetchClients(e);
                                        }}
                                        notFoundContent={"Entered organization not found!"}
                                    />
                                    {formValuesErr?.org_id && (
                                        <p className="text-sm text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-5 mt-2">
                                <div className="w-full">
                                    <label
                                        htmlFor="org_id"
                                        className={`ml-1.5 text-sm font-bold text-gray-900 dark:text-white`}
                                    >
                                        Client<span className="important">*</span>
                                    </label>
                                    <AntSelect
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        allowClear
                                        placeholder="Select Clients"
                                        optionFilterProp="children"
                                        className="h-[48px] w-full mt-[5px]"
                                        options={clients?.map((m: any) => {
                                        return {
                                            label: m?.name,
                                            value: m?.id,
                                        };
                                        })}
                                        value={formValues?.client_id || undefined}
                                        onChange={(e: any) => {
                                            setFormValues((preVal: any) => {
                                                return { ...preVal, client_id: e , gateway : "" };
                                            });
                                            setFormValuesErr((preVal: any) => {
                                                return { ...preVal, client_id: "" };
                                            });
                                            setAllGateways([])
                                            fetchGateways(e)
                                        }}
                                        notFoundContent={"Entered client not found!"}
                                    />
                                    {formValuesErr?.client_id && (
                                        <p className="text-sm text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-5 mt-2">
                                <div className="w-full">
                                    <label
                                        htmlFor="org_id"
                                        className={`ml-1.5 text-sm font-bold text-gray-900 dark:text-white`}
                                    >
                                        Gateway<span className="important">*</span>
                                    </label>
                                    <AntSelect
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        allowClear
                                        placeholder="Select Gateway"
                                        optionFilterProp="children"
                                        className="h-[48px] w-full mt-[5px]"
                                        options={allGateways?.map((m: any) => {
                                        return {
                                            ...m,
                                            label: singleRoleData?.[0]?.crypto?.value?.show_crypto_payout_gateway_name ? m.name : m.id,
                                            value: m?.id,
                                        };
                                        })}
                                        value={formValues?.gateway || undefined}
                                        onChange={(e: any) => {
                                            setFormValues((preVal: any) => {
                                                return { ...preVal, gateway: e };
                                            });
                                            setFormValuesErr((preVal: any) => {
                                                return { ...preVal, gateway: "" };
                                            });
                                        }}
                                        notFoundContent={"Entered gateway not found!"}
                                    />
                                    {formValuesErr?.gateway && (
                                        <p className="text-sm text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-5 mt-3 mb-4">
                                <div className="w-full ">
                                    <div className="flex flex-col ">
                                        <p className="mb-3 ml-1.5 text-sm font-bold text-gray-900">CSV File * <a href={Batch} download="SampleBatch.csv" className="ml-[5px]">Download Sample CSV</a></p>
                                        <FileDropzone label="Upload Batch CSV File" onFileSelect={setBatchFile} onRemoveFile={setRemoveFile}/>
                                    </div>
                                    {formValuesErr?.batch_file && (
                                        <p className="text-sm mt-1 text-orange-500">
                                        The field is required
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className="mt-[10px]">
                        <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                            <button
                            onClick={handleClose}
                            className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium  outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                            >
                                Close
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={isLoading}
                                className="linear update rounded-xl bg-indigo-600 px-5 py-2 text-base font-medium text-white outline-none transition duration-200  dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                            >
                                {isLoading ? (
                                    <DivLoader className="h-6 w-6 border-white" />
                                ) : (
                                <>{"Add Batch"}</>
                                )}
                            </button>
                        </div>
                    </ModalFooter>
                </Card>
            </Modal>
        </>
    );
}

export default AddBatchFile;
